
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/watchlist",
      function () {
        return require("private-next-pages/account/watchlist.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/watchlist"])
      });
    }
  